<template>
  <div class="common-banner">
    <div class="common-banner-item">
      <img class="banner-image" :src="bgImg" alt="" />
      <a-input-search
        placeholder="请输入关键字搜索"
        enter-button="搜索"
        @search="onSearch"
        v-if="search"
        class="common-banner-search"
        v-model="defaultValue"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bgImg: String,
    search: {
      type: Boolean,
      default: false
    },
    keywords: String
  },
  data() {
    return {
      defaultValue: ''
    }
  },
  methods: {
    onSearch(value) {
      this.$emit('search', value)
    }
  },
  watch: {
    keywords: {
      handler(nVal) {
        this.defaultValue = nVal
      },
      immediate: true,
      deep: true
    }
  },
}
</script>